import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { ShopLogoComponent } from '@plys/src/ui/shop-logo/shop-logo.component';
import { Observable } from 'rxjs';

export interface ErrorPageRouteData {
  titleKey: string;
  messageKey: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, TranslocoModule, ShopLogoComponent],
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
  data$ = this.route.data as Observable<ErrorPageRouteData>;

  constructor(private route: ActivatedRoute) {}
}
